module.exports = __webpack_public_path__ + "static/Marvella Francis Deacon-25429605b84047811d6ff1b80620cc1c.jpg";